import React from "react";
import { motion } from "framer-motion";
import { IoLogoWhatsapp } from "react-icons/io";
import { useLocation } from "react-router-dom";
import "./ContactFloat.css";

const ContactFloat = () => {
  const location = useLocation();

  const isBottomPage = ["/", "/hotel", "/flight", "/tour"].includes(
    location.pathname,
  );

  return (
    <div
      className={`contact-float-container ${isBottomPage ? "at-bottom" : "raised"}`}
    >
      <motion.a
        href="https://wa.me/918178035854"
        target="_blank"
        rel="noopener noreferrer"
        className="contact-button-whatsapp"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        <IoLogoWhatsapp className="whatsapp-icon" />
        <span className="whatsapp-text">Message Us</span>
      </motion.a>
    </div>
  );
};

export default ContactFloat;
